import { ViewableImpression } from '@lib/iab/iab-vast-model';

interface IViewableImpression {
    id: string;
    viewable?: UnmarshalerNode[];
    notViewable?: UnmarshalerNode[];
    viewUndetermined?: UnmarshalerNode[];
}

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const createViewableImpression = (
    $viewableImpression: IViewableImpression
): ViewableImpression => {
    const viewableImpression = new ViewableImpression();
    viewableImpression.id = $viewableImpression.id;

    if ($viewableImpression.viewable != null) {
        viewableImpression.viewables.push(
            ...$viewableImpression.viewable.map(
                (imp) => (imp as UnmarshalerNode)._value as string
            )
        );
    }

    if ($viewableImpression.notViewable != null) {
        viewableImpression.notViewables.push(
            ...$viewableImpression.notViewable.map(
                (imp) => (imp as UnmarshalerNode)._value as string
            )
        );
    }

    if ($viewableImpression.viewUndetermined != null) {
        viewableImpression.viewUndetermineds.push(
            ...$viewableImpression.viewUndetermined.map(
                (imp) => (imp as UnmarshalerNode)._value as string
            )
        );
    }

    return viewableImpression;
};

export default createViewableImpression;
